import clsx from "clsx";
import st from "@/styles/UserSidebar.module.scss";
import PlusItemsIcon from "@/svg/PlusIconItem.tsx";
import PlusIcon from "@/svg/PlusIcon.tsx";
import React, {ReactNode} from "react";
import {useTranslation} from "react-i18next";
import CommonClass from "@/utils/common.ts";
import DividerSimple from "@/ui/DividerSimple.tsx";
import {useAtom} from "jotai/index";
import {
    loan_sidebar_data
} from "@/atoms/profile.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import StandartCreditIcon from "@/svg/StandartCreditIcon.tsx";
import CreditLineIcon from "@/svg/CreditLineIcon.tsx";
import ClockIcon from "@/svg/ClockIcon.tsx";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import MultiButton from "@/ui/MultiButton.tsx";
import useLoans from "@/hooks/loans.ts";
import GeneralMenuOuter from "@/components/SideElements/elems/GenMenuOuter.tsx";
import StepsInterface from "@/types_and_interfaces/sidebar_steps_interface.ts";
import PromoIcon from "@/svg/PromoIcon.tsx";
import CMS from "@/utils/cms.ts";
import Button from "@/ui/Button.tsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import {pending_loans} from "@/atoms/common.ts";
import {items_on_page} from "@/utils/constants.ts";
import OpenScheduleModal from "@/ui/OpenScheduleModal.tsx";
import { isMobile } from 'react-device-detect';



interface Props {
    steps?:Array<StepsInterface>
}

interface MenuNavs {
    label: string
    badge_num?: number
    icon: ReactNode
    url:string
    rect_badge?: string
    visible: boolean
}

const GeneralMenu:React.FC<Props> = (props) => {

    const {
        steps
    } = props

    const [loan_data, ] = useAtom(loan_sidebar_data)
    const applyData = loan_data ? JSON.parse(loan_data) : {}
    
    const dc = DashboardClass
    const is_home = location.pathname === dc.dashboard_routes.Home
    const {t} = useTranslation()
    const loans = useLoans()
    const credit_line_loans = loans.getLoansByType("Credit Line")?.filter((x:any) => !["closed", "finished"]?.includes(x.status))
    const standart_credits = loans.getLoansByType("Reuseste")?.filter((x) => (x.r_status_simplified === "success" && x.r_status !== "settled"))
    
    const navigate = useNavigate();
    const have_steps = Array.isArray(steps) && steps.length
    const {step} = useParams()
    const [pend_loans] = useAtom(pending_loans)
    const is_apply_data = Boolean(typeof applyData === "object" && applyData !== null && Object.keys(applyData).length)
    // @ts-ignore
    const pend_status_loans = [...(pend_loans?.pending_submission || []),
        // @ts-ignore
        ...(pend_loans?.pending_approval || []),
        // @ts-ignore
        ...(pend_loans?.submitting || []),
        // @ts-ignore
        ...(pend_loans?.approved || []),
        // @ts-ignore
        ...(pend_loans?.approved_and_payment_pending || []),
        // @ts-ignore
        ...(pend_loans?.approved_and_received || []),
        // @ts-ignore
        ...(pend_loans?.approved_and_checked || []),
        // @ts-ignore
        ...(pend_loans?.approved_and_not_verified || []),
        // @ts-ignore
        ...(pend_loans?.approved_and_need_sign || []),
        // @ts-ignore
        ...(pend_loans?.transmission_error || []),
    ];
    
    
    const sidebar_navs:Array<MenuNavs> = [

        {
            label: t("standart_credit"),
            badge_num: Array.isArray(standart_credits) ? standart_credits.length || 0 : 0,
            icon: <StandartCreditIcon />,
            url: dc.dashboard_routes.StandartCredit,
            visible:true,
            rect_badge: "",
        },

        {
            label: t("line_credit"),
            badge_num: Array.isArray(credit_line_loans)? credit_line_loans.length : 0,
            icon: <CreditLineIcon />,
            url: dc.dashboard_routes.CreditLine,
            // visible:Boolean(credit_line_loans?.length),
            visible: Boolean(Array.isArray(credit_line_loans) && credit_line_loans.length),
            // rect_badge:(Array.isArray(credit_line_loans) && credit_line_loans.length) ? t("activated") : t("inactivated")
        },

        {
            label: t("pending_credit"),
            badge_num: pend_status_loans.length || 0,
            icon: <ClockIcon />,
            url: dc.dashboard_routes.PendingLoans,
            visible:true,
            rect_badge: ""
        },

        {
            label: t("news&promo"),
            badge_num: Array.isArray(CMS.getCabinetOffers()) ? CMS.getCabinetOffers().length : 0,
            icon: <PromoIcon />,
            url: dc.dashboard_routes.Promotions + `?offset=0&limit=${items_on_page}&page_number=1`,
            visible:true,
            rect_badge: ""
        },
    ]
    const queryParams = new URLSearchParams(location.search);
    const is_cr_line_param = queryParams.get("is_cr_line") || ""

    return (
        <GeneralMenuOuter>
            
            <div className={clsx(st.controllers, have_steps && st.with_steps)}>
                
                <div className={clsx(st.top_controllers , st.mobile_top_controllers)}>
                    <MultiButton
                        icon_left={<PlusItemsIcon/>}
                        icon_right={<PlusIcon/>}
                        active={is_home}
                        left_text={t("dashboard_home")}
                        left_function={() => {
                            navigate(dc.dashboard_routes.Home)
                        }}
                        right_function={() => {
                            eventEmitter.emit(CommonClass.ModalEvents.OpenCalculator, true)
                        }}
                    />
                </div>
                
                <div className={clsx(st.top_controllers, st.desktop_top_controllers)}>
                    
                    <Button
                        onClick={() => {
                            navigate(dc.dashboard_routes.Home)
                        }}
                        gray={!is_home}
                    >
                        <PlusItemsIcon/>
                        {t("dashboard_home")}
                    </Button>
                    
                </div>
                
                <div className={st.loans_nav}>
                    {(!isMobile && is_apply_data && location.pathname.includes(DashboardClass.dashboard_routes.SignContract) && is_cr_line_param === "") ? (
                        <ApplyCrLineData applyData={applyData}/>
                    ) : (
                        <>
                            <span>
                                {t("loans")}
                            </span>
                            
                            {sidebar_navs.map((loan: MenuNavs, i) => {
                                
                                const {
                                    label,
                                    badge_num,
                                    icon,
                                    url,
                                    rect_badge,
                                    visible
                                } = loan

                                let badge_nr = (typeof badge_num === "number" && badge_num > 99) ? "99+" : badge_num
                                
                                return visible ? (
                                    <button
                                        onClick={() => {
                                            localStorage.setItem(CommonClass.local_storage_fields.prev_path, url)
                                            navigate(url)
                                        }}
                                        key={`loans_nav_item_${i}`}
                                        className={clsx(st.loans_nav_item, url.includes(location.pathname) && st.active)}
                                    >
                                        
                                        <div className={st.label}>
                                            {icon} {label}
                                        </div>
                                        
                                        {Boolean(rect_badge?.length) ? (
                                            <div className={st.sq_badge}>
                                                {rect_badge}
                                            </div>
                                        ) : (
                                            <div className={st.badge}>
                                                {badge_nr && badge_nr}
                                            </div>
                                        )}
                                    
                                    </button>
                                ) : null
                            })}
                        </>
                    )}
                </div>
                
            </div>
            
            {have_steps && (
                
                <>
                    <div className={clsx(st.top_controllers, st.steps_top_controllers)}>
                        
                        <Button
                            onClick={() => {
                                navigate(dc.dashboard_routes.Home)
                            }}
                            gray={!is_home}
                        >
                            <PlusItemsIcon/>
                            {t("dashboard_home")}
                        </Button>
                    
                    </div>
                    
                    <div className={st.steps}>
                        
                        {steps.map((stp: StepsInterface, i) => {
                            
                            const {label, icon} = stp
                            
                            const active = step === (i + 1).toString()
                            
                            return (
                                <div className={clsx(st.stp, active && st.active)} key={`action_sidebar_steps_${i}`}>
                                    
                                    <div className={st.inf}>
                                        <span>
                                            {t("step") + " " + (i + 1)}
                                        </span>
                                        
                                        <span>
                                            {label}
                                        </span>
                                    </div>
                                    
                                    <div className={st.icon_cont}>
                                        {icon}
                                    </div>
                                    
                                    <div className={st.point}/>
                                
                                </div>
                            )
                        })}
                    </div>
                </>
            
            )}
        
        </GeneralMenuOuter>
    
    )
}


interface applyDataInterface {
    applyData: any
}

interface listItem {
    label: string
    val: string
    visible: boolean
    border: boolean
}

const ApplyCrLineData: React.FC<applyDataInterface> = ({applyData}) => {
    
    const {t} = useTranslation()
    const {amount, end, interest, period} = applyData
    const location = useLocation()
    
    
    const arr: Array<listItem> = [
        {
            label: t("credit_amount"),
            val: CommonClass.formatMoneyAmount(amount) + " " + t("currency"),
            visible: Boolean(amount),
            border: false
        },

        {
            label: t("period"),
            val: period + " " + t("months"),
            visible: Boolean(period),
            border: false,
        },
        {
            label: t("credit_end"),
            val: end,
            visible: Boolean(end),
            border: false,
        },
        {
            label: t("yearly_rate"),
            val: interest,
            visible: Boolean(interest),
            border: false,
        }
    ]
    

    
    return (
        <div className={st.cr_line_data}>
            
            <strong>
                {t("credit_data")}
            </strong>
            
            {/*<DividerSimple/>*/}
            
            {arr.map((x: listItem, i) => {
                
                const {label, val, border, visible} = x
                
                return visible && (
                    <React.Fragment key={`cr_line_data_${i}`}>
                        
                        <div className={st.data}>
                            <span className={st.label}>
                                {label}
                            </span>
                            
                            <span className={st.val}>
                                {val}
                            </span>
                        </div>
                        
                        {border && (
                            <DividerSimple/>
                        )}
                    
                    </React.Fragment>
                )
            })}
            
            {location.pathname.includes(DashboardClass.dashboard_routes.SignContract)  && (
                <OpenScheduleModal />
            )}
        
        </div>
    )
}

export default GeneralMenu